"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toVueSidebarMenus = void 0;
const constants_1 = require("../constants");
const domainAdminSet = new Set(constants_1.DOMAIN_ADMIN_ROLES);
function isDomainAdminOnlyRoles(roles) {
    if (!(roles === null || roles === void 0 ? void 0 : roles.length))
        return false;
    return roles.length === domainAdminSet.size && roles.every(r => domainAdminSet.has(r));
}
function submenuMeta(node, t) {
    const meta = {
        label: t(node.msg),
    };
    if (node.permission)
        meta.permission = node.permission;
    if (node.adminRoleOnly || node.adminOnly)
        meta.roles = ['admin'];
    else if (isDomainAdminOnlyRoles(node.roles))
        meta.roles = node.roles.slice();
    return meta;
}
function sectionMeta(node, t, ctx) {
    var _a, _b;
    const meta = { label: t(node.msg) };
    if ((_a = node.roles) === null || _a === void 0 ? void 0 : _a.length)
        meta.roles = node.roles.slice();
    if ((_b = node.visibility) === null || _b === void 0 ? void 0 : _b.includes('adminMode')) {
        meta.hidden = () => !ctx.isAdminMode();
    }
    return meta;
}
/**
 * Build CloudPods-style `menus` array from filtered or full `NavNode[]`.
 * Pass `i18n.t.bind(i18n)` as `t` if your i18n instance needs binding.
 */
function toVueSidebarMenus(nodes, t, ctx) {
    const out = [];
    for (const n of nodes) {
        const hasChildren = n.children && n.children.length > 0;
        if (n.type === 'group' || hasChildren) {
            out.push({
                meta: sectionMeta(n, t, ctx),
                submenus: n.children.map(child => ({
                    path: child.path,
                    meta: submenuMeta(child, t),
                })),
            });
            continue;
        }
        if (n.path) {
            out.push({
                meta: sectionMeta(n, t, ctx),
                submenus: [
                    {
                        path: n.path,
                        meta: submenuMeta(n, t),
                    },
                ],
            });
        }
    }
    return out;
}
exports.toVueSidebarMenus = toVueSidebarMenus;
